/**
 * Phone dial codes for the country-code selector used on phone-number
 * inputs (Settings > Account today; reuse this list, don't duplicate it,
 * anywhere else a phone field needs a country-code picker).
 *
 * Not the same list as `countries.ts` (country NAMES for address fields) --
 * this one pairs a name with its ISO code and international dial code.
 * Covers the most common markets; add a row here to extend it, no other
 * code changes needed.
 */
export interface PhoneCountryCode {
  iso: string;
  name: string;
  dialCode: string;
}

export const phoneCountryCodes: PhoneCountryCode[] = [
  { iso: 'US', name: 'United States', dialCode: '+1' },
  { iso: 'CA', name: 'Canada', dialCode: '+1' },
  { iso: 'MX', name: 'Mexico', dialCode: '+52' },
  { iso: 'GT', name: 'Guatemala', dialCode: '+502' },
  { iso: 'BZ', name: 'Belize', dialCode: '+501' },
  { iso: 'SV', name: 'El Salvador', dialCode: '+503' },
  { iso: 'HN', name: 'Honduras', dialCode: '+504' },
  { iso: 'NI', name: 'Nicaragua', dialCode: '+505' },
  { iso: 'CR', name: 'Costa Rica', dialCode: '+506' },
  { iso: 'PA', name: 'Panama', dialCode: '+507' },
  { iso: 'CO', name: 'Colombia', dialCode: '+57' },
  { iso: 'VE', name: 'Venezuela', dialCode: '+58' },
  { iso: 'EC', name: 'Ecuador', dialCode: '+593' },
  { iso: 'PE', name: 'Peru', dialCode: '+51' },
  { iso: 'BO', name: 'Bolivia', dialCode: '+591' },
  { iso: 'CL', name: 'Chile', dialCode: '+56' },
  { iso: 'AR', name: 'Argentina', dialCode: '+54' },
  { iso: 'UY', name: 'Uruguay', dialCode: '+598' },
  { iso: 'PY', name: 'Paraguay', dialCode: '+595' },
  { iso: 'BR', name: 'Brazil', dialCode: '+55' },
  { iso: 'DO', name: 'Dominican Republic', dialCode: '+1' },
  { iso: 'PR', name: 'Puerto Rico', dialCode: '+1' },
  { iso: 'CU', name: 'Cuba', dialCode: '+53' },
  { iso: 'JM', name: 'Jamaica', dialCode: '+1' },
  { iso: 'GB', name: 'United Kingdom', dialCode: '+44' },
  { iso: 'IE', name: 'Ireland', dialCode: '+353' },
  { iso: 'FR', name: 'France', dialCode: '+33' },
  { iso: 'DE', name: 'Germany', dialCode: '+49' },
  { iso: 'ES', name: 'Spain', dialCode: '+34' },
  { iso: 'PT', name: 'Portugal', dialCode: '+351' },
  { iso: 'IT', name: 'Italy', dialCode: '+39' },
  { iso: 'NL', name: 'Netherlands', dialCode: '+31' },
  { iso: 'BE', name: 'Belgium', dialCode: '+32' },
  { iso: 'CH', name: 'Switzerland', dialCode: '+41' },
  { iso: 'AT', name: 'Austria', dialCode: '+43' },
  { iso: 'SE', name: 'Sweden', dialCode: '+46' },
  { iso: 'NO', name: 'Norway', dialCode: '+47' },
  { iso: 'DK', name: 'Denmark', dialCode: '+45' },
  { iso: 'FI', name: 'Finland', dialCode: '+358' },
  { iso: 'PL', name: 'Poland', dialCode: '+48' },
  { iso: 'IN', name: 'India', dialCode: '+91' },
  { iso: 'CN', name: 'China', dialCode: '+86' },
  { iso: 'JP', name: 'Japan', dialCode: '+81' },
  { iso: 'KR', name: 'South Korea', dialCode: '+82' },
  { iso: 'PH', name: 'Philippines', dialCode: '+63' },
  { iso: 'AU', name: 'Australia', dialCode: '+61' },
  { iso: 'NZ', name: 'New Zealand', dialCode: '+64' },
  { iso: 'ZA', name: 'South Africa', dialCode: '+27' },
  { iso: 'NG', name: 'Nigeria', dialCode: '+234' },
  { iso: 'AE', name: 'United Arab Emirates', dialCode: '+971' },
  { iso: 'SA', name: 'Saudi Arabia', dialCode: '+966' },
];

export const DEFAULT_PHONE_ISO = 'US';
